var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 26,
    viewBox: "0 0 23 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.675 11.9391C19.2737 17.8261 21.868 19.6222 21.868 19.6222H2.01172C2.01172 19.6222 5.30448 17.3272 5.30448 9.04547C5.32719 7.21072 5.99882 5.44327 7.2003 4.05646C7.7958 3.40336 8.51963 2.88018 9.32657 2.51963C10.1335 2.15909 11.0062 1.96894 11.89 1.96107C12.2586 1.94467 12.6279 1.97824 12.9875 2.06085",
    stroke: "#E9A5F3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7839 22.915C13.57 23.2287 13.2992 23.4994 12.9856 23.7133C12.6562 23.9166 12.275 24.0205 11.888 24.0126C11.501 24.0205 11.1199 23.9166 10.7904 23.7133C10.4768 23.4994 10.206 23.2287 9.99219 22.915",
    stroke: "#E9A5F3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.10314 11.9391C4.50445 17.8261 1.91016 19.6222 1.91016 19.6222H21.7664C21.7664 19.6222 18.4737 17.3272 18.4737 9.04547C18.451 7.21072 17.7794 5.44327 16.5779 4.05646C15.9824 3.40336 15.2585 2.88018 14.4516 2.51963C13.6446 2.15909 12.772 1.96894 11.8882 1.96107C11.5195 1.94467 11.1503 1.97824 10.7906 2.06085",
    stroke: "#E9A5F3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.2805ca1f264b52cde022618e24f20abf.svg";
export { ForwardRef as ReactComponent };